import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupModal from "../../components/PopupModal/PopupModal";

const NotAuthorized = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const handleOk = () => {
    setOpen(false);

    // Check if there's history to go back to
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      // Fallback: send them to a safe default page
      navigate("/user/dashboard", { replace: true });
    }
  };

  return (
    <PopupModal
      open={open}
      title="Access Denied"
      message="Sorry, you don’t have access to this page."
      onOk={handleOk}
    />
  );
};

export default NotAuthorized;
